import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
const TEAM_MEMBERS_QUERY_NAME = 'teamMembers';
export const TeamMembersQuery = registerQuery({
  fieldName: TEAM_MEMBERS_QUERY_NAME,
  args: ['userIds'],
  fetcher: async ({
    userIds
  }) => {
    const response = await http.put('users/v2/app/hub-users/bulk', {
      data: userIds
    });
    return response.userBriefs;
  }
});
export const useFetchTeamMembers = userIds => {
  return useQuery(TeamMembersQuery, {
    variables: {
      userIds
    },
    skip: !(userIds !== null && userIds !== void 0 && userIds.length)
  });
};